import React from 'react';
import { GetUrlVars } from '../services/data.service';
import { withTranslation } from "react-i18next";

class Welcome extends React.Component {
  constructor() {
    super();
    this.state = {

    }
  }

  render() {
    const { t, title, content } = this.props;
    const welcomeTitle = title || t('welcome_title')
    const welcomeText = content || t("welcome_text", { address: this.state.address || t("default_address") });

    return (<section className="z-10 text-gray-700 body-font">
      <div className="relative z-10 container px-5 mt-4 mx-auto">
        <div className="z-10 xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
          <h2 className="w-full my-2 text-2xl font-bold leading-tight text-center text-gray-800">{welcomeTitle}</h2>
          <div className="w-full mb-4"><div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div></div>
          <p className="leading-relaxed text-lg text-center whitespace-pre-line" dir="auto">
            {welcomeText}
          </p>

        </div>
      </div>
      <br/>
      <br/>
    </section>);
  }
componentDidMount(){
  const params = GetUrlVars();
  if (params.address) {
    this.setState({
      address: decodeURIComponent(params.address)
    })
  }
}

}

// Wrap component with withTranslation HOC for class components
export default withTranslation()(Welcome);
